import _ from "lodash";

export const JOB_PROFILE = 'job-profile';
export const APPLICATION = 'application';

export function get (characteristic, labelType)
{
	const characteristicLabel = characteristic.label;

	if (!labelType)
	{
		return characteristicLabel;
	}

	const labelAllocation = _.find(
		characteristic.labels || [],
		alloc => alloc.type.id === labelType
	);

	return labelAllocation?.label || characteristicLabel;
}